import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, ValidatePhone } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { AddressFieldDisplayModel } from "@insite/client-framework/Types/ApiModels";

const getRequiredErrorMessage = (addressFieldDisplayCollection: AddressFieldDisplayModel) =>
    siteMessage("Field_Required", addressFieldDisplayCollection.displayName);

const isEmpty = (value: string) => value.trim().length <= 0;
const isValidPhoneNumber = (value: string) => {
    value = value.replace(/\D/g, "");
    return value.length === 10;
};

replaceInChain(chain, ValidatePhone, props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { phone } = props.parameter.address;
    if (addressFieldDisplayCollection.phone?.isVisible && validationRules.phone?.isRequired && isEmpty(phone)) {
        props.addressErrors.phone = getRequiredErrorMessage(addressFieldDisplayCollection.phone);
    } else if (!isEmpty(phone) && !isValidPhoneNumber(phone)) {
        props.addressErrors.phone = siteMessage("AddressInfo_Phone_Validation");
    }
});
